# This directive scrolls element to the percent of total scroll height.
# Using of the listener is because the element has to be visible when listener catches an event.
# Usage: <ul class="options-list" scroll-to-percent>
angular.module('rjmNg.directives').directive "scrollToPercent", [
  () ->
    restrict: "A"
    link: (scope, element, attr) ->

      _scrollToPercent = (percent) ->
        element.scrollTop(element[0].scrollHeight * percent)

      scrollToPercentListener = scope.$on(
        "scrollToPercent"
        (event, percent) ->
          _scrollToPercent(percent)
      )

      _cleanUp = () ->
        scrollToPercentListener()
        return

      scope.$on('$destroy', _cleanUp)
]
